import { SharedModule } from './shared/shared.module';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieModule } from 'ngx-cookie';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { CookiesBannerComponent } from './cookies-banner/cookies-banner.component';
import { config } from '@fortawesome/fontawesome-svg-core';
import { HttpClientModule } from '@angular/common/http';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

config.autoAddCss = false;

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        FooterComponent,
        CookiesBannerComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'shapeupspain-app'}),
        TransferHttpCacheModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        CookieModule.forRoot(),
        NgbModalModule,
        BrowserTransferStateModule,
        FontAwesomeModule
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
